<template>
  <footer class="fixed-bottom footer">
    <div class="center">Copyright (c) Broadleaf Co., Ltd. All rights reserved.</div>
  </footer>
</template>

<script>
export default {
  name: 'global-footer'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/partials/GlobalFooter.vue